import type { IMetadata } from './common.type';
import type {
  DocumentData,
  DocumentReference,
  WhereFilterOp,
} from 'firebase/firestore';

type TData = Record<string, any>;
type TCollectionPath = string;
type TDocument = string;

export enum ESort {
  ASC = 'asc',
  DESC = 'desc',
}

export interface IDocRefProps {
  collectionPath: Required<TCollectionPath>;
  document: Required<TDocument>;
}

export interface IAddProps {
  collectionPath: TCollectionPath;
  data?: TData;
}

export interface IWriteProps extends IDocRefProps {
  data?: TData;
}

export interface IReadAllProps {
  collectionPath: TCollectionPath;
}

export interface IReadByProps extends IReadAllProps {
  wheres: Array<{
    field: string;
    operator?: WhereFilterOp;
    value: any;
  }>;
  optional?: {
    order?: string;
    orderDirection?: ESort;
    limit?: number;
    offset?: number;
  };
}

export interface IReadByRefProps {
  reference: DocumentReference<DocumentData, DocumentData>;
}

export interface IFindByIdProps extends Omit<IDocRefProps, 'document'> {
  document?: TDocument;
  reference?: DocumentReference<DocumentData, DocumentData>;
}

export interface IUpdateProps extends IDocRefProps {
  data: TData;
}

export type IDeleteProps = IDocRefProps;

export interface IFirestoreEntity {
  id: string;
  metadata: IMetadata;

  [key: string]: any;
}
